function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #d21c3a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_73",
  "data-name": "Rectangle 73",
  className: "cls-1",
  width: 25.763,
  height: 32.304
})));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Group_34",
  "data-name": "Group 34",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1413",
  "data-name": "Path 1413",
  className: "cls-3",
  d: "M23.286,3.963h-5.45V2.973A2.976,2.976,0,0,0,14.864,0H10.9A2.976,2.976,0,0,0,7.928,2.973v.992H2.476A2.479,2.479,0,0,0,0,6.441V9.909a.989.989,0,0,0,.953.989H24.809a.991.991,0,0,0,.955-.989V6.441a2.481,2.481,0,0,0-2.478-2.478M9.908,2.973a.993.993,0,0,1,.992-.992h3.964a.992.992,0,0,1,.992.992v.992H9.908Z",
  transform: "translate(0 0.001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1414",
  "data-name": "Path 1414",
  className: "cls-3",
  d: "M32.026,80.561H10.491l.835,17.549a2.969,2.969,0,0,0,2.969,2.832H29.344a2.969,2.969,0,0,0,2.969-2.832l.835-17.549ZM17.856,96.9a.991.991,0,1,1-1.982,0V84.023a.991.991,0,0,1,1.982,0Zm4.954,0a.991.991,0,1,1-1.981,0V84.023c0-.02,0-.041,0-.061a.991.991,0,0,1,1.981.061Zm4.954,0a.991.991,0,1,1-1.982,0V84.023c0-.02,0-.04,0-.061a.991.991,0,1,1,1.982.061Z",
  transform: "translate(-8.938 -68.637)"
}));
const SvgCancel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_66",
    "data-name": "Group 66",
    width: 25.764,
    height: 32.304,
    viewBox: "0 0 25.764 32.304",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.69b3075d.svg";
export { ForwardRef as ReactComponent };